<template>
  <HeaderComponent />

  <main class="min-h-screen relative pt-14 xl:pt-24">
    <section class="u-container">
      <article
        class="xl:w-2/3 mx-auto bg-white px-6 xl:px-28 py-20 text-center border shadow-md rounded-2xl relative z-10"
      >
        <p class="text-sm mb-16">
          “Compra en miles de tiendas de todo el mundo y recíbelo en casa”
        </p>
        <h2 class="text-mainBlue text-xl xl:text-3xl font-bold mb-6">
          Hola, Bienvenido 🤩
        </h2>
        <img
          src="../assets/images/usuario-compartido.png"
          class="mx-auto mb-6"
        />
        <h3 class="text-2xl xl:text-4xl mb-8 font-normal">
          Tu amigo @{{ name }}
        </h3>
        <p class="font-bold text-sm xl:text-xl mb-10">
          Te ha compartido $ 10 <span class="text-mainBlue">USD</span> <br />
          para comprar en nuestra plataforma
        </p>
        <button
          @click.prevent="changeView"
          class="text-sm xl:text-base block mx-auto mb-28 py-4 px-28 text-white bg-mainGreenLight rounded-xl"
        >
          Registrate
        </button>
      </article>
    </section>
    <img
      class="absolute inset-0 object-cover w-full h-screen"
      src="../assets/images/bg-flujo-compra.png"
      alt="Mosaico..."
    />
  </main>


</template>
<script>
import HeaderComponent from "../components/global/headerComponent.vue";
import { server } from "../config/global";
const BASE_URL = server.API_URL;
//librerias
import axios from "axios";
export default {
  components: { HeaderComponent },
  data() {
    return {
      code: this.$route.params.code,
      name: null,
    };
  },
  created() {
    if (localStorage.getItem("auth")) {
      this.$router.push({ name: "Home" });
    }
  },
  mounted() {
    this.getNameCodeUser();
  },
  methods: {
    changeView() {
      location.href = "https://app.sendi.com.pe/?invitation=" + this.code;
    },
    getNameCodeUser() {
      axios
        .get(`${BASE_URL}` + "client/getById/" + this.code)
        .then((response) => {
          this.name =
            response.data.body.data.attributes.profile.attributes.name;
        })
        .catch(() => {
          //----------component--------//
          this.$store.state.alert.titulo = "Error";
          this.$store.state.alert.description = "Error al obtener datos";
          this.$store.state.alert.estado = true;
          //--------------------------//
        });
    },
  },
};
</script>
